<template>
	<div>
    <button
      onclick="document.querySelector('body').webkitRequestFullscreen();this.remove()"
      class="fullscreen"
    >Fullscreen</button>
		<section class="wrapper wrapper--mobile" v-if="box">
			<section class="pickup">
				<div class="pickup__top">
					<h3>Bestellung zur Abholung bereit</h3>
				</div>
				<div class="pickup__middle">
					<div class="pickup__number">
            <span v-html="$options.filters.fwgshortorder(box.number)"/>
            <div class="pickup__arrow">
              <img :src="asset(themeValue('THEME_PAYMENT_ARROW'))" alt="">
            </div>
          </div>
					<div class="pickup__name">{{ box.order_label }}</div>
				</div>
				<div class="pickup__bottom">
					<a
						href="javascript:void(0)"
						class="pickup__button button button--primary"
						@click="onPickup"
					>Hol deine Bestellung ab</a>
				</div>
			</section>
		</section>

    <section v-else class="wrapper wrapper--mobile wrapper--no-margin">
      <section class="pickup pickup--empty">
        <div class="pickup__empty">
          &#171; BOX {{ boxNumber }} &#187;
        </div>
      </section>
    </section>

		<section class="thank-you" v-if="showSuccess">
			<div class="wrapper wrapper--mobile">
				<div class="thank-you__text">
					<h1>Thank you for your order</h1>
					<span>See you soon!</span>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { startUpdateOrderListInterval, updateOrder } from "@num/controller"
import { config } from "@num/config"

export default {
  data() {
    return {
      successTime: 5000,
      showSuccess: false,
      arrowDirection: "down", //up down
    };
  },
  computed: {
    box() {
      return this.$root.$data.orderList.filterByAttr("status", this.$root.$data.orderFilter)[0]
    },
    boxNumber() {
      //TODO: the number should be gathered elsewhere
      return this.$root.$data.orderFilter.split(",")[0].replace("in_box_", "").replace("in_prep_", "")
    },
  },
  methods: {
    onPickup() {
      let box = {
        id: this.box.id,
        status: "done"
      }
      updateOrder(box)
      this.displaySuccess()
    },
    displaySuccess() {
      this.showSuccess = true
      clearTimeout(this.successTimeout)
      this.successTimeout = setTimeout(() => {
        this.showSuccess = false
      }, this.successTime)
    }
  },
  mounted() {
    //TODO: basic url parameter reading, should be done in a better way
    if (config.filter) {
      this.$root.$data.orderFilter = config.filter
      this.arrowDirection = this.$root.$data.pickupArrowMap[this.$root.$data.orderFilter]
      startUpdateOrderListInterval(this.$root.$data.orderFilter)
    }
  }
};
</script>

<style>
</style>
